const FFIcon = props => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 91' {...props}>
      <path d='m97.83,39.85L60.16,2.19c-1.51-1.51-3.37-2.19-5.19-2.19-3.81,0-7.47,2.96-7.47,7.43v29.6L12.66,2.19c-1.51-1.51-3.37-2.19-5.19-2.19C3.66,0,0,2.96,0,7.43v75.34c0,4.47,3.66,7.43,7.47,7.43,1.82,0,3.68-.68,5.19-2.19l34.84-34.84v29.6c0,4.47,3.66,7.43,7.47,7.43,1.82,0,3.68-.68,5.19-2.19l37.67-37.67c2.9-2.9,2.9-7.59,0-10.49Zm-51.04,6.95L9.12,84.47c-.48.48-1.04.72-1.65.72-.95,0-2.47-.66-2.47-2.43V7.43c0-1.77,1.51-2.43,2.47-2.43.62,0,1.18.24,1.65.72l37.67,37.67c.62.62.71,1.33.71,1.71s-.09,1.09-.71,1.71Zm47.5,0l-37.67,37.67c-.48.48-1.04.72-1.65.72-.95,0-2.47-.66-2.47-2.43V7.43c0-1.77,1.51-2.43,2.47-2.43.62,0,1.18.24,1.65.72l37.67,37.67c.62.62.71,1.33.71,1.71s-.09,1.09-.71,1.71Z' />
    </svg>
  );
};

export default FFIcon;
